import dayjs from 'dayjs';

import { IInputFilterValue } from '@components/FilterBlock';

import { IOrdersFilters } from '../interfaces';

export const DATE_VALUE_FORMAT = 'YYYY-MM-DD';

export interface ICustomerFilterValue {
  value?: number;
}

export interface IStatusFilterValue {
  value?: string[];
}

// Календарные даты без времени
export interface IDateRangeValue {
  from?: string;
  to?: string;
}

// Значения блока фильтров: ключ - имя условия
export interface IOrdersFilterValues {
  customer_scope_id?: ICustomerFilterValue;
  recipient?: IInputFilterValue;
  delivery_city?: IInputFilterValue;
  delivery_address?: IInputFilterValue;
  created?: IDateRangeValue;
  delivery_date?: IDateRangeValue;
  status?: IStatusFilterValue;
}

const toText = (filter?: IInputFilterValue): string | undefined => String(filter?.value ?? '').trim() || undefined;

export const toOrdersFilters = (values: IOrdersFilterValues): IOrdersFilters => ({
  customer_scope_id: values.customer_scope_id?.value || undefined,
  recipient: toText(values.recipient),
  delivery_city: toText(values.delivery_city),
  delivery_address: toText(values.delivery_address),
  // Заказ создан в момент времени: границы - начало и конец дня пользователя
  created_from: values.created?.from ? dayjs(values.created.from).startOf('day').toISOString() : undefined,
  created_to: values.created?.to ? dayjs(values.created.to).endOf('day').toISOString() : undefined,
  // Дата доставки календарная, по поясу не сдвигается
  delivery_date_from: values.delivery_date?.from || undefined,
  delivery_date_to: values.delivery_date?.to || undefined,
  status: values.status?.value?.length ? values.status.value : undefined,
});
